import dayjs from "dayjs";

import { GraphhopperBillingType } from "constants/enums";
import { AxiosError } from "axios";

export const convertToPoints = (latlngs: { lat: number; lng: number }[]) => {
  return latlngs.map((item) => [item.lng, item.lat]);
};

export const convertToLatLng = (point: number[]) => ({
  lat: point[1],
  lng: point[0],
});

export const convertToLatLon = (point: number[]) => ({
  lat: point[1],
  lon: point[0],
});

export const decodePath = function (encoded: string, is3D: boolean) {
  let len = encoded.length;
  let index = 0;
  let array = [];
  let lat = 0;
  let lng = 0;
  let ele = 0;

  while (index < len) {
    let b;
    let shift = 0;
    let result = 0;
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    let deltaLat = result & 1 ? ~(result >> 1) : result >> 1;
    lat += deltaLat;

    shift = 0;
    result = 0;
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);
    let deltaLon = result & 1 ? ~(result >> 1) : result >> 1;
    lng += deltaLon;

    if (is3D) {
      // elevation
      shift = 0;
      result = 0;
      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);
      let deltaEle = result & 1 ? ~(result >> 1) : result >> 1;
      ele += deltaEle;
      array.push([lng * 1e-5, lat * 1e-5, ele / 100]);
    } else array.push([lng * 1e-5, lat * 1e-5]);
  }
  // let end = new Date().getTime();
  // console.log("decoded " + len + " coordinates in " + ((end - start) / 1000) + "s");
  return array;
};

export const getKeyBillingType = (createdAt: number) => {
  const CreditsPerDay = Object.freeze({
    [GraphhopperBillingType.Free]: 500,
    [GraphhopperBillingType.Standard]: 15000,
  });

  const currentDate = dayjs();
  const keyDate = dayjs.unix(createdAt);
  const difference = currentDate.diff(keyDate, "weeks");

  const type =
    difference >= 2
      ? GraphhopperBillingType.Free
      : GraphhopperBillingType.Standard;

  return { type, maxCreditsPerDay: CreditsPerDay[type] };
};

interface GraphhopperError {
  message?: string;
  hints?: { message: string }[];
}

export const decodeError = (error: unknown) => {
  const err = error as AxiosError<GraphhopperError>;

  const { status = 0, data } = err.response ?? {};

  let errorMessage = "Graphhopper Unknown Error";
  const { hints, message } = data ?? {};

  if (hints && hints.length > 0 && hints[0] && hints[0].message) {
    errorMessage = hints[0].message;
  } else if (message) {
    errorMessage = message;
  }

  return { status, message: errorMessage };
};
